import { useEffect, useState } from 'react';
import { Chip } from '@mui/material';
import {
  EezyguardPriority,
  EezyguardSeverity,
  EezyguardStatus,
  PRIORITY_LABELS,
  SEVERITY_LABELS,
  STATUS_LABELS,
  getEezyguardCapabilities,
} from 'src/apis/eezyguard';

// Cores alinhadas à paleta do sistema (verde de marca + semânticas).
export const STATUS_COLORS: Record<EezyguardStatus, string> = {
  received: '#3f9fff',
  under_review: '#e0a106',
  in_progress: '#7c5cff',
  completed: '#2e9e5b',
  archived: '#7b8794',
  unsubstantiated: '#9aa5b1',
};

export const SEVERITY_COLORS: Record<EezyguardSeverity, string> = {
  baixa: '#2e9e5b',
  media: '#3f9fff',
  alta: '#e0a106',
  critica: '#d64545',
};

export const PRIORITY_COLORS: Record<EezyguardPriority, string> = {
  baixa: '#2e9e5b',
  media: '#3f9fff',
  alta: '#e0a106',
  critica: '#d64545',
};

export function StatusChip({ status }: { status: EezyguardStatus }): JSX.Element {
  return (
    <Chip
      size="small"
      label={STATUS_LABELS[status] ?? status}
      sx={{ bgcolor: STATUS_COLORS[status], color: '#fff', fontWeight: 600 }}
    />
  );
}

export function SeverityChip({ severity }: { severity: EezyguardSeverity }): JSX.Element {
  return (
    <Chip
      size="small"
      variant="outlined"
      label={SEVERITY_LABELS[severity] ?? severity}
      sx={{ borderColor: SEVERITY_COLORS[severity], color: SEVERITY_COLORS[severity] }}
    />
  );
}

export function PriorityChip({
  priority,
}: {
  priority: EezyguardPriority | null;
}): JSX.Element {
  if (!priority) return <Chip size="small" label="—" variant="outlined" />;
  return (
    <Chip
      size="small"
      label={PRIORITY_LABELS[priority] ?? priority}
      sx={{ bgcolor: PRIORITY_COLORS[priority], color: '#fff', fontWeight: 600 }}
    />
  );
}

// Hook de capacidade: resolve no backend se o usuário é admin EezyGuard.
export function useEezyguardAdmin(): { isAdmin: boolean; loading: boolean } {
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    getEezyguardCapabilities()
      .then((res) => active && setIsAdmin(Boolean(res.is_eezyguard_admin)))
      .catch(() => active && setIsAdmin(false))
      .finally(() => active && setLoading(false));
    return () => {
      active = false;
    };
  }, []);

  return { isAdmin, loading };
}
